import {
  CustomerNotificationStatusEnum,
  ICustomerNotificationSelectOptionsDTO,
} from "@hooks/dtos/ICustomerNotificationDTO";

export const customerNotificationStatusSelect: ICustomerNotificationSelectOptionsDTO[] =
  [
    {
      status: CustomerNotificationStatusEnum.READ,
      text: "Lida",
      description: "Notificações lidas.",
    },
    {
      status: CustomerNotificationStatusEnum.UNREAD,
      text: "Não lida",
      description: "Notificações não lidas.",
    },
  ];
